import { Component, inject } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { MAINTENANCE_BRANDING } from './maintenance-branding';

@Component({
  selector: 'app-maintenance-page',
  imports: [RktIconComponent],
  templateUrl: './maintenance-page.component.html',
  styleUrl: './maintenance-page.component.scss',
  standalone: true,
})
export class MaintenancePageComponent {
  readonly branding = inject(MAINTENANCE_BRANDING);
}
